import React from 'react';
import PropTypes from 'prop-types';
import InputFileTableRow from './components/InputFileTableRow';

import './styles.css';

const InputFileTable = props => {
  const { files, onRemoveHandler, onChangeHandler } = props;

  return (
    <div className="input-file-group">
      {files.map(file => (
        <InputFileTableRow
          key={file.FileID}
          file={file}
          onRemoveHandler={onRemoveHandler}
          onChangeHandler={onChangeHandler}
        />
      ))}
    </div>
  );
};

InputFileTable.propTypes = {
  files: PropTypes.array.isRequired,
  onRemoveHandler: PropTypes.func,
  onChangeHandler: PropTypes.func,
};

export default InputFileTable;
